import { HttpClient } from '@angular/common/http'
import { Injectable, inject } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'
import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'
import { FieldDto } from './dtos/field.dto'
import { TechniqueNames } from './dtos/technique.dto'

@Injectable()
export class FieldService {
  private http = inject(HttpClient)
  private translateService = inject(TranslateService)

  private baseUrl = 'charts/charts'

  private static returnParsedLabel(
    techniqueName: TechniqueNames,
    fieldName?: string,
  ): string {
    if (typeof fieldName === 'string') {
      if (techniqueName) {
        const fieldCode = fieldName.replace(techniqueName.toUpperCase(), '')
        return `PROJECT_MANAGEMENT.CHARTS.PROPERTIES.${fieldCode}`
      }
    }
    return fieldName
  }

  getFields(techniqueName: TechniqueNames): Observable<FieldDto[]> {
    return this.http
      .get<FieldDto[]>(`${this.baseUrl}/${techniqueName}/fields`)
      .pipe(
        map(fields =>
          fields.map(field => ({
            ...field,
            displayName: this.translateService.instant(
              FieldService.returnParsedLabel(techniqueName, field?.name),
            ) as string,
          })),
        ),
      )
  }
}
